import { RecordAny } from '@dealstack/shared/lib/common/common';
import styled from 'styled-components';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { createSortableTextHeader } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnHeader/ColumnHeader';
import { Box } from '@mantine/core';

type Props<T extends RecordAny> = ExtendedColumnDef<T> & {
	accessorKey: keyof T;
	showFooter?: boolean;
	footerValue?: string | number;
	headerText?: string;
	enableSorting?: boolean;
};

export const createBooleanColumn = <T extends RecordAny>({
	showFooter = false,
	footerValue,
	headerText,
	enableSorting = true,
	...columnDef
}: Props<T>): ExtendedColumnDef<T> => {
	return {
		accessorFn: (row) => {
			const key = columnDef.accessorKey;
			return row?.[key] ?? false;
		},
		header: headerText ? createSortableTextHeader(headerText, enableSorting) : columnDef.header,
		columnLabel: columnDef.columnLabel ?? headerText ?? '',
		enableSorting,
		cell: ({ cell }) => {
			const value = cell.getValue<boolean>();
			return <BooleanIndicator $isTrue={value} />;
		},
		footer: showFooter
			? () => (
					<Box fw={600} ta="center">
						{footerValue}
					</Box>
				)
			: undefined,
		...columnDef,
	};
};

const BooleanIndicator = styled.div<{ $isTrue: boolean }>`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: ${({ $isTrue, theme }) =>
		$isTrue ? theme.v3.colors.green[2] : theme.v3.colors.red[2]};
`;
